import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { useAuth } from '@/lib/auth';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Briefcase, FileText, MapPin, UserCheck } from 'lucide-react';

interface Kpis { clients: number; policies: number; sites: number; staff_registered: number }

export const BrokerDashboard: React.FC = () => {
  const [kpis, setKpis] = useState<Kpis | null>(null);
  const { user } = useAuth();
  useEffect(() => { api.get<Kpis>('/dashboard/broker-kpis').then(r => setKpis(r.data)); }, []);
  return (
    <div className="space-y-6 animate-fade-in">
      <div>
        <h2 className="font-headline text-3xl text-raptor-navy tracking-wide">Welcome back</h2>
        <p className="text-sm text-raptor-navy/60 font-body">Your brokerage view (<span className="font-tabular">{user?.broker_id}</span>). Clients, policies and sites appear here as your account is populated.</p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {[
          { l: 'Clients', v: kpis?.clients ?? 0, i: <Briefcase size={18} />, g: true },
          { l: 'Policies', v: kpis?.policies ?? 0, i: <FileText size={18} />, g: true },
          { l: 'Sites', v: kpis?.sites ?? 0, i: <MapPin size={18} />, g: true },
          { l: 'Staff registered', v: kpis?.staff_registered ?? 0, i: <UserCheck size={18} />, g: false },
        ].map((t) => (
          <Card key={t.l} className={t.g ? 'opacity-60' : ''}>
            <CardContent className="p-4">
              <div className="flex items-start justify-between">
                <div>
                  <div className="text-xs text-raptor-navy/60 font-body">{t.l}</div>
                  <div className="font-tabular text-3xl font-bold text-raptor-navy mt-1">{t.v}</div>
                </div>
                <div className="w-9 h-9 rounded-md bg-raptor-blue/10 flex items-center justify-center text-raptor-blue">{t.i}</div>
              </div>
              {t.g && <div className="mt-2"><Badge variant="muted">Coming soon</Badge></div>}
            </CardContent>
          </Card>
        ))}
      </div>
      <Card>
        <CardHeader><CardTitle>You&apos;re all set</CardTitle></CardHeader>
        <CardContent className="text-sm text-raptor-navy/70 font-body">
          When Osprey&apos;s risk team issues a survey instruction against one of your clients, you&apos;ll receive an email and an in-portal notification with the next steps.
        </CardContent>
      </Card>
    </div>
  );
};
